import { theme } from '@primer/react';
import ThemeReferenceTree from '~/src/components/theme-reference-tree';
import * as React from 'react';
export default {
  theme,
  ThemeReferenceTree,
  React
};